import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00302e49"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新建空间", -1))


const __default__ = {
  name: 'SelectTemplate2'
}

import Icon from '@teams/common/components/icon'
import { NModal, NCard } from 'naive-ui'
import { ref, VNode, onMounted, onBeforeUnmount } from 'vue'
import SelectTemplate from './selectTemplate.vue'
import {
  open,
  closeSelectTemplateDialog,
  evtBus,
  EvtBusListenerType
} from './hooks'

export type TemplateType = {
  templateImg?: string
  templateTitle?: string
  templateDetail?: string
  templateId: number
  pcImg?: string
  phoneImg?: string
  content1?: {
    title: string
    info: string
  }
  content2?: {
    title: string
    info: string[]
  }
  content3?: {
    title: string
    info: string[]
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    addIcon: null,
    isLogin: { type: Boolean },
    noModal: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  addIcon?: () => VNode
  isLogin?: boolean
  // TODO: 后续要把 modal 独立出来！！！不要用这种方式
  noModal?: boolean
}

const dialog = ref(false)
const openDialog = () => {
  open()
}
const closeDialog = () => {
  closeSelectTemplateDialog()
}


const handleEvtBus: EvtBusListenerType = eventName => {
  const handlers: {
    [key in typeof eventName]?: (...args: unknown[]) => unknown
  } = {
    open() {
      dialog.value = true
    },
    close() {
      dialog.value = false
    }
  }
  handlers[eventName]?.()
}
onMounted(() => {
  evtBus.on(handleEvtBus)
})
onBeforeUnmount(() => {
  evtBus.off(handleEvtBus)
})

expose({
  openCreateSpaceDialog: openDialog
})

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!!props.addIcon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: openDialog,
          style: {"cursor":"pointer"}
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.addIcon)))
        ]))
      : (_openBlock(), _createBlock(_component_n_tooltip, {
          key: 1,
          trigger: "hover"
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_n_button, {
              class: "addButton",
              onClick: openDialog,
              secondary: "",
              disabled: !__props.isLogin
            }, {
              icon: _withCtx(() => [
                (__props.isLogin)
                  ? (_openBlock(), _createBlock(_unref(Icon), {
                      key: 0,
                      name: "addGroup",
                      size: 16,
                      fill: "transparent"
                    }))
                  : (_openBlock(), _createBlock(_unref(Icon), {
                      key: 1,
                      name: "addGroupColorGray",
                      size: 16,
                      fill: "transparent"
                    }))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })),
    (!props.noModal)
      ? (_openBlock(), _createBlock(_unref(NModal), {
          key: 2,
          show: dialog.value,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
          "on-mask-click": closeDialog
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NCard), {
              style: {"width":"1120px","min-width":"1120px","min-height":"654px"},
              bordered: false,
              size: "huge",
              role: "dialog",
              "aria-modal": "true"
            }, {
              default: _withCtx(() => [
                _createVNode(SelectTemplate, { onCloseSelectTemplateDialog: closeDialog })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})